export const CHANGE_TOKEN = "CHANGE_TOKEN";

export function changeToken(token) {
  return {
    token,
    type: CHANGE_TOKEN
  };
}
